import React, { useEffect, useState, memo } from "react";
import { TransformComponent, TransformWrapper } from "react-zoom-pan-pinch";
import { ZoomIn, ZoomOut, ZoomRestore } from "../../../../assets/images";
import Spinner from "../../Conversation/Templates/Common/Spinner";
import { calculateDimension, generateCanvas } from "../../../../Helpers/Chat/canvasImg";

const CanvasImage = React.memo(({uniqueId, imgSrc, generateThumb}) => {
    const canvasId = `${uniqueId}_media_preview_canvas`;
    const [canvasDrawDimension, setCanvasDrawDimension] = useState({
        width: 0,
        height: 0
    });
    const [canvasDimension, setCanvasDimension] = useState({
        width: 0,
        height: 0
    });
    const [imgDimension, setImgDimension] = useState({
        width: 0,
        height: 0
    });
    const [imgObj, setImgObj] = useState(null);
    const [reRender, setReRender] = useState(true);

    useEffect(() => {
        getImageDimension();
    }, []);

    useEffect(() => {
        if(imgObj && canvasId && canvasDimension.width && canvasDimension.height && canvasDrawDimension.width && canvasDrawDimension.height){
            generateCanvas({img: imgObj, canvasId, canvasDimension, canvasDrawDimension});
            setReRender(!reRender);
        }
    }, [canvasDrawDimension.width, canvasDrawDimension.height]);

    useEffect(() => {
        if(!imgDimension.width) return;
        getAndSetCanvasDimension();
        if(generateThumb){
            generateThumb();
        }

        window.addEventListener('resize', () => {
            getAndSetCanvasDimension();
        });

        return () => {
            window.removeEventListener('resize', () => {
                getAndSetCanvasDimension();
            });
        }
    }, [imgDimension.width]);

    const getImageDimension = () => {
        const img = document.createElement('img');
        img.src = imgSrc;
        
        img.onload = () => {
            setImgObj(img);
            setImgDimension({width:img.width, height:img.height});
        }
    }

    const getAndSetCanvasDimension = () => {
        const dimensions = calculateDimension(`${uniqueId}_imageZoomWrapper`, imgDimension);
        if(dimensions){
            setCanvasDimension(dimensions.canvasDimension);
            setCanvasDrawDimension(dimensions.canvasDrawDimension);
        }
    }

    return <div className={`imageZoomWrapper`}  id={`${uniqueId}_imageZoomWrapper`}>
        {!canvasDrawDimension.width && !canvasDrawDimension.height && <Spinner />}
        <TransformWrapper>
        {({ zoomIn, zoomOut, resetTransform, ...rest }) => (
            <React.Fragment>
            {/* <div className="tools zoomTools">
                <button onClick={zoomIn}>
                <ZoomIn />
                </button>
                <button onClick={zoomOut}>
                <ZoomOut />
                </button>
                <button onClick={resetTransform}>
                <ZoomRestore />
                </button>
            </div> */}
            <TransformComponent>
                <canvas className="canvas" id={canvasId} width={canvasDrawDimension.width} height={canvasDrawDimension.height} style={{width: `${canvasDrawDimension.width}px`, height: `${canvasDrawDimension.height}px`}}> </canvas>
            </TransformComponent>
            </React.Fragment>
        )}
        </TransformWrapper>
    </div>
});

export default CanvasImage;